// extracted by mini-css-extract-plugin
module.exports = {"bucketsList":"CuratedBuckets--bucketsList","listEndSpacer":"CuratedBuckets--listEndSpacer","bucketCard":"CuratedBuckets--bucketCard","title":"CuratedBuckets--title"};